// extracted by mini-css-extract-plugin
export default {"cluster":"PunchupLineupCard_cluster__rzott","avatar":"PunchupLineupCard_avatar__w-Xu3","overflowCount":"PunchupLineupCard_overflowCount__In8Wi"};